import { lazy } from 'react';

/** Public API of the docs feature: the `/docs` frame, its pages and the lookups route loaders need. */
export { DocsShell } from './components/docs-shell';
export { findGuide } from './content';
export { findOperation, landsOnDocs } from './lookup';
export { EndpointPage } from './pages/endpoint-page';
export { GettingStartedPage } from './pages/getting-started-page';
export { GuidePage } from './pages/guide-page';
export { DocsNotFoundPage } from './pages/not-found-page';
export { PostmanPage } from './pages/postman-page';
export { ReferenceIndexPage } from './pages/reference-index-page';

/** Its own chunk: the builder and the fragments it loads stay out of the docs shell's. */
export const BuildPage = lazy(async () => {
  const { BuildPage: Page } = await import('./pages/build-page');
  return { default: Page };
});
